__turbopack_context__.v({
  "btn": "EWonUG_btn",
  "default": "EWonUG_default",
  "primary": "EWonUG_primary",
  "secondary": "EWonUG_secondary",
  "tertiary": "EWonUG_tertiary",
  "tertiary-inverse": "EWonUG_tertiary-inverse",
  "tertiaryInverse": "EWonUG_tertiaryInverse",
});
